module.exports = __webpack_public_path__ + "img/line_claw.8117b0f4.svg";